import { useEffect, useState } from "react"
import { Container } from "@mui/material"
import { I18nextProvider } from 'react-i18next'
import i18config from '../../../helpers/i18n'
import { ThemeProvider } from '@mui/material'
import theme from '../../../helpers/theme'
import RecurringPaymentPage from "../RecurringPaymentPage/RecurringPaymentPage"
import RecurringPaymentAcknowledgementPage from "../AcknowledgementPage/AcknowledgementPage"
import { MembershipPaymentRouteProps } from "../../membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"

enum RecurringPaymentRoute {
    Main,
    Acknowledgement
}

function RecurringPaymentFlow(props: MembershipPaymentRouteProps) {
    const [route, setRoute] = useState<RecurringPaymentRoute | null>()
    const { onNavigateTo } = props

    useEffect(() => {
        if (window.myNtucConfig.recurringPaymentCallbackUrl != null && window.location.href.startsWith(window.myNtucConfig.recurringPaymentCallbackUrl)) {
            setRoute(RecurringPaymentRoute.Acknowledgement)
        } else {
            setRoute(RecurringPaymentRoute.Main)
        }
    }, [])

    const currentPage = () => {
        switch (route) {
            case RecurringPaymentRoute.Main:
                return <RecurringPaymentPage />
            case RecurringPaymentRoute.Acknowledgement:
                return <RecurringPaymentAcknowledgementPage onNavigateTo={onNavigateTo} />
        }
    }

    return (
        <I18nextProvider i18n={i18config}>
            <ThemeProvider theme={theme}>
                <Container id='main-container'>
                    {currentPage()}
                </Container>
            </ThemeProvider>
        </I18nextProvider>
    )
}

export default RecurringPaymentFlow
